module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plm_hd"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_serpref"
    }
  }, [_vm._v("Series preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_autpref"
    }
  }, [_vm._v("Authors’ preface")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_abbrev"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch01"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("1 Introduction")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch01#sigil_toc_id_2"
    }
  }, [_vm._v("Our idea: exploring the exposed iceberg")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch01#sigil_toc_id_3"
    }
  }, [_vm._v("Our criteria: New Testament summaries of Israel’s story")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch01#sigil_toc_id_4"
    }
  }, [_vm._v("Our method: context, content and contribution")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch02"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("2 Matthew and Israel’s continuing story")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch02#sigil_toc_id_6"
    }
  }, [_vm._v("The context of Matthew’s genealogy")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch02#sigil_toc_id_7"
    }
  }, [_vm._v("The content of Matthew’s genealogy (Matt. 1:1–17)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch02#sigil_toc_id_8"
    }
  }, [_vm._v("The context of the parable of the tenants")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch02#sigil_toc_id_9"
    }
  }, [_vm._v("The content of the parable of the tenants (Matt. 21:33–46)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch02#sigil_toc_id_10"
    }
  }, [_vm._v("Reading Israel’s story with Matthew")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch02#sigil_toc_id_11"
    }
  }, [_vm._v("The great commission and Israel’s story in Matthew’s Gospel")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch02#sigil_toc_id_12"
    }
  }, [_vm._v("The contribution of Matthew’s summaries")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch02#sigil_toc_id_13"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("3 Luke, Acts and the climax of Israel’s story")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch03#sigil_toc_id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The context: the Gospel of Luke")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch03#sigil_toc_id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The context: Acts")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch03#sigil_toc_id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The context of Stephen’s speech")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch03#sigil_toc_id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The content of Stephen’s speech (Acts 7)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch03#sigil_toc_id_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary of Stephen’s speech")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch03#sigil_toc_id_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The context of Paul’s sermon")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch03#sigil_toc_id_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The content of Paul’s sermon (Acts 13:16–41)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch03#sigil_toc_id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary of Paul’s sermon")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch03#sigil_toc_id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The contribution of Luke’s summaries")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch03#sigil_toc_id_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("4 Galatians and Israel’s law")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch04#sigil_toc_id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The context of Paul’s summary")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch04#sigil_toc_id_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The content of Paul’s summary (Gal. 3 – 4)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch04#sigil_toc_id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The contribution of Paul’s summary")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch04#sigil_toc_id_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("5 Romans and Israel’s identity")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch05#sigil_toc_id_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The context of Paul’s summary")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch05#sigil_toc_id_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The content of Paul’s summary (Rom. 9 – 11)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch05#sigil_toc_id_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The contribution of Paul’s summary")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch05#sigil_toc_id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("6 Hebrews and Israel’s inheritance")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch06#sigil_toc_id_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The context of Hebrews’s summary")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch06#sigil_toc_id_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The content of Hebrews’s summary (Heb. 11)")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch06#sigil_toc_id_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The contribution of Hebrews’s summary")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch06#sigil_toc_id_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold2"
  }, [_vm._v("7 Conclusion: a biblical-theological rule of faith")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch07#sigil_toc_id_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary of the contributions")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch07#sigil_toc_id_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biblical-theological prescriptions")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_ch07#sigil_toc_id_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Israel’s story and our stories")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1s"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_bibliog",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_idxaut",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Search names for authors")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_idxscrip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Search items for Scripture references")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_sertit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Titles in this series")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_BibTheol_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_ata",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/NSBT_moreIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02d03904","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/NSBT_BibTheol_contents.vue
// module id = 66
// module chunks = 0